import { Suspense, lazy, useRef, createContext } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useState, useEffect } from 'react';
import { RouteTracker } from "./helpers/analytics";
import { getBrandFromCookie } from "./helpers/product";
import "./assets/css/landing-header.css";
import "./assets/css/header-zindex-fix.css";
import { useParams, useNavigate } from 'react-router-dom';

export const VoiceWidgetContext = createContext(null);

// home pages
const HomeFashion = lazy(() => import("./pages/home/HomeFashion"));
const ChatProvider = lazy(() => import("./components/chatai/ChatProvider"));

const HomeElectronics = lazy(() => import("./pages/home/HomeElectronics"));
const HomeElectronicsThree = lazy(() => import("./pages/home/HomeElectronicsThree"));
const HomeBookStoreTwo = lazy(() => import("./pages/home/HomeBookStoreTwo"));

// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"));
const ShopGridPromoTron = lazy(() => import("./pages/shop/ShopGridPromoTron"));
const ShopGridFilter = lazy(() => import("./pages/shop/ShopGridFilter"));
const ShopGridTwoColumn = lazy(() => import("./pages/shop/ShopGridTwoColumn"));
const ShopGridNoSidebar = lazy(() => import("./pages/shop/ShopGridNoSidebar"));
const ShopGridFullWidth = lazy(() => import("./pages/shop/ShopGridFullWidth"));
const ShopGridRightSidebar = lazy(() =>
  import("./pages/shop/ShopGridRightSidebar")
);
const ShopListStandard = lazy(() => import("./pages/shop/ShopListStandard"));
const ShopListFullWidth = lazy(() => import("./pages/shop/ShopListFullWidth"));
const ShopListTwoColumn = lazy(() => import("./pages/shop/ShopListTwoColumn"));

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));
const ProductPromoTron = lazy(() => import("./pages/shop-product/ProductPromoTron"));
const ProductTabLeft = lazy(() =>
  import("./pages/shop-product/ProductTabLeft")
);
const ProductTabRight = lazy(() =>
  import("./pages/shop-product/ProductTabRight")
);
const ProductSticky = lazy(() => import("./pages/shop-product/ProductSticky"));
const ProductSlider = lazy(() => import("./pages/shop-product/ProductSlider"));
const ProductFixedImage = lazy(() =>
  import("./pages/shop-product/ProductFixedImage")
);

// blog pages
const BlogStandard = lazy(() => import("./pages/blog/BlogStandard"));
const BlogNoSidebar = lazy(() => import("./pages/blog/BlogNoSidebar"));
const BlogRightSidebar = lazy(() => import("./pages/blog/BlogRightSidebar"));
const BlogDetailsStandard = lazy(() =>
  import("./pages/blog/BlogDetailsStandard")
);

// other pages
const About = lazy(() => import("./pages/other/About"));
const Newcombo = lazy(() => import("./pages/other/Newcombo"));
const SkuLanding = lazy(() => import("./pages/other/SkuLanding"));
const Landing = lazy(() => import("./pages/other/Landing"));
const BlogLanding = lazy(() => import("./pages/other/BlogLanding"));
const BlogPost = lazy(() => import("./pages/other/BlogPost"));
const AddToWish = lazy(() => import("./pages/other/AddToWish"));
const CompareAdd = lazy(() => import("./pages/other/CompareAdd"));
const CartAdd = lazy(() => import("./pages/other/CartAdd"));
const Contact = lazy(() => import("./pages/other/Contact"));
const AvisoLegal = lazy(() => import("./pages/other/AvisoLegal"));
const CookiePolicy = lazy(() => import("./pages/other/CookiePolicy"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const Orders = lazy(() => import("./pages/other/Orders"));
const OrderDetail = lazy(() => import("./pages/other/OrderDetail"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));

const NotFound = lazy(() => import("./pages/other/NotFound"));
const FormularioCampana = lazy(() => import("./pages/other/formularioCampana"));
const ProtectedRoute = lazy(() => import("./components/ProtectedRoute"));

// Removed brand redirect components - no longer needed
const ConditionalChatProvider = ({ voiceRef }) => {
  const location = useLocation();
  if (location.pathname === process.env.PUBLIC_URL + '/formulario') return null;
  return <ChatProvider ref={voiceRef} assistantId="ee70eb548741662e9d13d9add74dccdf"/>;
};

const App = () => {


const PackRedirect = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { pack_sector } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchPackData = async () => {
      try {
        console.log('Pack Sector:', pack_sector);
        
        const response = await fetch(`https://ca816ed0-67a5-454a-b749-5b5632ff4c5d.clouding.host/api/combo_sectors/${pack_sector}`);
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        const data = await response.json();
        
        // Navigate using React Router instead of window.location
        navigate(`/wishlist?pack_sku=${data}`);
      } catch (error) {
        console.error('Error fetching pack data:', error);
        // Handle the error appropriately
     //   navigate('/'); // Redirect to home on error
      } finally {
        setIsLoading(false);
      }
    };

    fetchPackData();
  }, [pack_sector, navigate]);
  
  // Show loading indicator while fetching data
  if (isLoading) {
    return (
      <div className="loading-container">
        Loading...
      </div>
    );
  }
  
  return null;
};
  // Simplified: Always use Creoo's home element
  const voiceRef = useRef(null);
  const homeElement = <Landing />;
  return (
      <Router>
       <RouteTracker />
       <VoiceWidgetContext.Provider value={voiceRef}>
       <ScrollToTop>
          <Suspense
            fallback={
              <div className="flone-preloader-wrapper">
                <div className="flone-preloader">
                  <span></span>
                  <span></span>
                </div>
              </div>
            }
          >
          <ConditionalChatProvider voiceRef={voiceRef} />
            <Routes>
               <Route
                path={process.env.PUBLIC_URL + "/formulario"}
                element={<ProtectedRoute><FormularioCampana/></ProtectedRoute>}
              />



{/* Removed brand redirect routes - no longer needed */}
<Route path={process.env.PUBLIC_URL + "/ref/:sku"} element={<SkuLanding />} />
<Route path={process.env.PUBLIC_URL + "/pack/:pack_sector"} element={<ProtectedRoute><PackRedirect/></ProtectedRoute>} />
<Route path={process.env.PUBLIC_URL + "/newcombo/*"} element={<ProtectedRoute><Newcombo /></ProtectedRoute>} />
<Route path={process.env.PUBLIC_URL + "/add_to_wish/:product_id"} element={<ProtectedRoute><AddToWish /></ProtectedRoute>} />
<Route path={process.env.PUBLIC_URL + "/add_compare/:product_ids"} element={<ProtectedRoute><CompareAdd /></ProtectedRoute>} />
<Route path={process.env.PUBLIC_URL + "/add_cart/:budget"} element={<ProtectedRoute><CartAdd /></ProtectedRoute>} />
{/* Removed brand-specific category routes - no longer needed */}
         

              <Route
                path={process.env.PUBLIC_URL + "/pack/:id"}
                element={<ProtectedRoute><ProductSlider/></ProtectedRoute>}
              />


                 <Route
              path={process.env.PUBLIC_URL + "/home"}
              element={<ProtectedRoute><Landing /></ProtectedRoute>}
            />
              <Route
              path={process.env.PUBLIC_URL + "/"}
                             element={<ProtectedRoute>{homeElement}</ProtectedRoute>}

            />
              <Route
                path={process.env.PUBLIC_URL + "/blog"}
                element={<ProtectedRoute><BlogLanding /></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/blog/:slug"}
                element={<ProtectedRoute><BlogPost /></ProtectedRoute>}
              />

              {/* Homepages */}
           
              {/* Shop pages */}
            <Route
                path={process.env.PUBLIC_URL + "/test-home"}
                element={<ProtectedRoute><HomeElectronicsThree/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/shop-grid-standard"}
                element={<ProtectedRoute><ShopGridPromoTron/></ProtectedRoute>}
              />
                <Route
                path={process.env.PUBLIC_URL + "/shop-grid-standard1"}
                element={<ProtectedRoute><ShopGridPromoTron/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/shop-grid-filter"}
                element={<ProtectedRoute><ShopGridFilter/></ProtectedRoute>}
              />

              <Route
                path={process.env.PUBLIC_URL + "/shop-list-standard"}
                element={<ProtectedRoute><ShopListStandard/></ProtectedRoute>}
              />
              

              <Route
                path={process.env.PUBLIC_URL + "/shop-grid-promotron"}
                element={<ProtectedRoute><ShopGridPromoTron /></ProtectedRoute>}
              />

              {/* Shop product pages */}
              <Route
                path={process.env.PUBLIC_URL + "/product/:id"}
                element={<ProtectedRoute><Product /></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/product-promotron/:id"}
                element={<ProtectedRoute><ProductPromoTron /></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/product-tab-left/:id"}
                element={<ProtectedRoute><ProductTabLeft/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/product-tab-right/:id"}
                element={<ProtectedRoute><ProductTabRight/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/product-sticky/:id"}
                element={<ProtectedRoute><ProductSticky/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/product-slider/:id"}
                element={<ProtectedRoute><ProductSlider/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/product-fixed-image/:id"}
                element={<ProtectedRoute><ProductFixedImage/></ProtectedRoute>}
              /> 

              {/* Blog pages 
              <Route
                path={process.env.PUBLIC_URL + "/blog-standard"}
                element={<BlogStandard/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/blog-no-sidebar"}
                element={<BlogNoSidebar/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/blog-right-sidebar"}
                element={<BlogRightSidebar/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/blog-details-standard"}
                element={<BlogDetailsStandard/>}
              /> 
*/}
              {/* Other pages */}
              <Route
                path={process.env.PUBLIC_URL + "/about"}
                element={<ProtectedRoute><About/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/contact"}
                element={<ProtectedRoute><Contact/></ProtectedRoute>}
              />
               <Route
                path={process.env.PUBLIC_URL + "/aviso-legal"}
                element={<ProtectedRoute><AvisoLegal/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/cookie-policy"}
                element={<ProtectedRoute><CookiePolicy/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/contacto"}
                element={<ProtectedRoute><Contact/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/my-account"}
                element={<ProtectedRoute><MyAccount/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/my-orders"}
                element={<ProtectedRoute><Orders /></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/my-orders/:orderId"}
                element={<ProtectedRoute><OrderDetail /></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/login-register"}
                element={<LoginRegister/>}
              />

              <Route
                path={process.env.PUBLIC_URL + "/cart"}
                element={<ProtectedRoute><Cart/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/wishlist"}
                element={<ProtectedRoute><Wishlist/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/compare"}
                element={<ProtectedRoute><Compare/></ProtectedRoute>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/checkout"}
                element={<ProtectedRoute><Checkout/></ProtectedRoute>}
              /> 

              <Route path="*" element={<NotFound/>} />





       


        
            </Routes>
          </Suspense>
        </ScrollToTop>
       </VoiceWidgetContext.Provider>
      </Router>
  );
};

export default App;